module.exports = __webpack_public_path__ + "img/no_internet.1917d13a.svg";